import wavezio from "../Images/wavezio.png";
import { IoIosArrowDropleft, IoIosArrowDropright } from "react-icons/io";
import Slider, { Settings } from "react-slick";

export const OurWork = () => {
  const CustomPrevArrow = (props: any) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} size-[64px] bg-[#2A2A2F] absolute left-[-20px]m top-[50%]m transform -translate-y-1/2 z-10`}
        onClick={onClick}
        style={{ ...style, display: "block" }}
      >
        <IoIosArrowDropleft className="text-[#DBE5E5] text-3xl" />
      </div>
    );
  };

  const CustomNextArrow = (props: any) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} size-[64px]m bg-[#2A2A2F]m absolute right-[-20px] top-[50%] transform -translate-y-1/2 z-10 flex items-center justify-center`}
        onClick={onClick}
        style={{ ...style, display: "block" }}
      >
        <IoIosArrowDropright className="text-[#DBE5E5] text-3xlm" />
      </div>
    );
  };

  const settings3: Settings = {
    rtl: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnFocus: true,
    pauseOnHover: true,
    autoplaySpeed: 3000,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  return (
    <section
      id="our-work"
      className="h-[855px] bg-[#1B1B22] flex flex-col items-center"
    >
      <div className="mx-auto w-[95vw] md:w-[80vw]">
        <div className="h-[122px] flex items-center mt-7">
          <hr className=" rotate-180 bg-[#09A7E4] h-[32px] w-[6px] rounded-[50px]" />{" "}
          <div className="text-[#09A7E4] leading-[100%] tracking-[0%] ml-3">
            <span className="font-medium text-[20px]">OUR</span>
            <br />
            <span className="font-bold text-[30px]">Work</span>
          </div>
        </div>

        <Slider {...settings3}>
          {[
            {
              image: wavezio,
              description:
                "Comforting to have such a professional partner on call to help you. Creativity delivered what others couldn't; cost-effective and timely.",
              name: "Wavezio mobile and webapp",
              company: "Chairman, StormX",
            },
            {
              image: wavezio,
              description:
                "Comforting to have such a professional partner on call to help you. Creativity delivered what others couldn't; cost-effective and timely.",
              name: "Wavezio mobile and webapp",
              company: "Chairman, StormX",
            },
          ].map((dt, index) => (
            <div
              key={index}
              className="h-[607px] flex flex-col items-center justify-center z-[5] text-[#FFFFFF]"
            >
              <div className="my-[34px] h-[85%] rounded-[30px] bg-[#2A2A2F] flex flex-col md:flex-row items-center p-[10px] md:p-[30px]">
                <div className="w-[95%] md:w-[65%] h-[70%] md:h-full bg-[#1E1E21] rounded-[20px] flex items-center justify-center">
                  <img src={dt.image} alt={dt.name} />
                </div>

                <div className="py-[40px] h-fit flex flex-col ml-[30px]">
                  <div className="text-[#F0FBFF] font-medium leading-[100%] tracking-[0%] text-[25px] md:text-[40px] text-center md:text-left">
                    {dt.name}
                  </div>

                  <button className="mx-auto md:mx-0 bg-[#0FB8F9] text-[#F5F5F5] px-6 h-[45px] md:h-[50px] rounded-[30px] mt-10 w-[180px] md:w-[211px] flex items-center justify-between">
                    <div className="text-base md:text-xl leading-[36px] tracking-[0%]">
                      Learn more
                    </div>
                    <div className="size-[30px] bg-[#EBEBEB] rounded-[50%] ml-2 flex items-center justify-center">
                      <IoIosArrowDropright className="text-xl text-[#09A7E4]" />
                    </div>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};
